import React, { useState, useEffect } from "react";
import { Row, Col, Card, CardBody, Input, Label, Button, Form, Alert } from "reactstrap";
import { get, put, post } from "../../helpers/api_helper";
import Breadcrumbs from "../../components/Common/Breadcrumb"
import { Trans } from 'react-i18next';
import { useNavigate, useParams } from "react-router-dom";
import Loader from "common/loader";
import { SHOW_TASK, UPDATE_TASK, LANGUAGES_SEARCH, DELIVERY_TYPE_SEARCH, DRIVER_TYPE_SEARCH } from "helpers/api_endpoints";
import MapComponent from "../../components/Common/Map"
import Select from "react-select";



//meta title
document.title = "Edit Task";

const EditTask = () => {
    const [loading, setLoading] = useState(true);
    const params = useParams();
    const [id, setid] = useState('');
    const [name, setName] = useState('');
    const [symbol, setSymbol] = useState('');
    const [status, setStatus] = useState(0);
    const [ord, setOrd] = useState(0);
    const [relateToOrder, setRelateToOrder] = useState(1);
    const [addressType, setAddressType] = useState(1);
    const [addressTypes, setAddressTypes] = useState([{value:1,label:"Pickup"}, {value:2,label:"Drop"}]);
    const [driverTypes, setDriverTypes] = useState([]);
    const [deliveryTypeId, setDeliveryTypeId] = useState('');
    const [driverTypeId, setDriverTypeId] = useState('');
    const [actionTypeId, setActionTypeId] = useState('');
    const [deliveryTypes, setDeliveryTypes] = useState([]);
    const [valued, setValued] = useState({"title":[]});
    const [languages, setLanguages] = useState([]);
    const [errorMsg, seterrorMsg] = useState('');
    const navigate = useNavigate();

    useEffect(() => {
        get(`${SHOW_TASK}/${params.id}`)
            .then(response => {
                const Task = response.data;
                setid(params.id);
                setName(Task.name);
                setOrd(Task.ord);
                setAddressType(Task.addressType);
                setDeliveryTypeId(Task.deliveryTypeId);
                setDriverTypeId(Task.driverTypeId);
                setActionTypeId(Task.actionTypeId);
                setRelateToOrder(Task.relateToOrder);
                if(Task.named != '')
                    setValued(Task.named);
                setStatus(Task.status);
                setLoading(false);
            })
            .catch(error => {console.log(error)
                // navigate('/tasks');
            })
    }, [deliveryTypes]);

    useEffect(() => {
        post(`${DELIVERY_TYPE_SEARCH}`)
            .then(response => {
                const data = response.data.map((el,index)=>{
                    return {value:el.id,label:el.nameTranslated}; 
                });
                setDeliveryTypes(data);
                // setLoading(false);
            })
            .catch(error => {
                console.log(error)
                if (error.response.status == 400) {
                    navigate('/logout');
                }
            })
        post(`${DRIVER_TYPE_SEARCH}`)
            .then(response => {
                const data = response.data.map((el,index)=>{
                    return {value:el.id,label:el.name}; 
                });
                setDriverTypes(data);
                // setLoading(false);
            })
            .catch(error => {
                console.log(error)
                if (error.response.status == 400) {
                    navigate('/logout');
                }
            })
    }, []);


    useEffect(() => {
        post(`${LANGUAGES_SEARCH}`,{status:1})
            .then(response => {
                setLanguages(response.data);
                // setLoading(false);
            })
            .catch(error => {
                console.log(error)
            })
    }, []);

    const handleSubmit = () => {
        put(UPDATE_TASK, { id, name, deliveryTypeId, addressType, relateToOrder, status, driverTypeId, actionTypeId, ord })
            .then(response => {
                if (response.code == 200) {
                    navigate('/tasks', { state: { successMsg: 'Task Updated SuccessFully' } });
                }
            })
            .catch(error => {
                console.log(error.response);
            })
    }

    const handleName = (languageId,value) => {
        if(valued.title == undefined)
        {
            setValued({"title":[]})
        }
        const ln = valued.title.filter(el =>{
            return Object.keys(el)[0] == languageId;
        })
        if(ln==undefined || ln.length <1)
        {
            const ob = {};
            ob[languageId] = value;
            valued.title.push(ob);
        }
        else
        {
            ln[0][languageId] = value;
        }
        setName(JSON.stringify(valued));             
    }
	const handleFilter = (type,value) => {
		switch(type)
		{
			case 'deliveryTypeId':
				{
					setDeliveryTypeId(value);
					break;
				}
			case 'addressType':
				{
					setAddressType(value);
					break;
				}
            case 'name':
                {
                    break;
                }
			default:
				break;
		}

	}

    return (
		<React.Fragment>
			<div className="page-content">
				<div className="container-fluid">
					<Breadcrumbs title="tasks" breadcrumbItem="Edit Task" />
					<Form
						className="form-horizontal"
						onSubmit={(e) => {
							e.preventDefault();
							handleSubmit();
							return false;
						}}
					>
						<Row>
							<Col xl={12}>
								<Card>
									<CardBody>
										<Row>
											{errorMsg ? <Alert color="danger">{errorMsg}</Alert> : null}
											{
												languages.map((language, index) => (
													<Row key={index}>
													<div className="form-group col-md-4 mt-2">
                                                        <Label className="form-label"><Trans>Name ({language.name})</Trans></Label>
                                                        <Input
                                                            name="name"
                                                            value={valued.title?valued.title.find(el => {return el[language.id]})?valued.title.find(el => {return el[language.id]})[language.id]:'':JSON.stringify(valued)}
                                                            className="form-control"
                                                            placeholder="Enter  Name"
                                                            type="text"
                                                            onChange={(e) => handleName(language.id,e.target.value)}
                                                            required={language.id==1||language.id==2?true:false} 
                                                            ></Input>
                                                    </div>
												</Row>
                                                ))
											}
											
											<div className="form-group col-md-4 mt-2">
                                                <Label className="form-label"><Trans>Action ID</Trans></Label>
                                                <Input
                                                    name="actionTypeId"
                                                    value={actionTypeId}
                                                    className="form-control"
                                                    placeholder="Enter  Name"
                                                    type="text"
                                                    onChange={(e) => setActionTypeId(e.target.value)}
                                                    ></Input>
                                            </div>

											<div className="form-group col-md-4 mt-2">
                                                <Label className="form-label"><Trans>Task Order</Trans></Label>
                                                <Input
                                                    name="ord"
                                                    value={ord}
                                                    className="form-control"
                                                    placeholder="Enter  Order"
                                                    type="number"
                                                    onChange={(e) => setOrd(e.target.value)}
                                                    ></Input>
                                            </div>

											<div className="form-group col-md-4 mt-2">
												<Label className="form-label"><Trans>Delivery Type</Trans></Label>
												<Select
													name="deliveryTypeId"
													value={deliveryTypes.filter(el=>{return el.value==deliveryTypeId})}
													options={deliveryTypes} 
													className="form-control select2"
													onChange={(e) => handleFilter('deliveryTypeId', e.value)}
													/>
											</div>

											<div className="form-group col-md-4 mt-2">
												<Label className="form-label"><Trans>Address Type</Trans></Label>
												<Select
													name="addressType"
													options={addressTypes} 
													value={addressTypes.filter(el=>{return el.value==addressType})}
													className="form-control select2"
													onChange={(e) => handleFilter('addressType', e.value)}
													/>
											</div>

											<div className="form-group col-md-4 mt-2">
												<Label className="form-label"><Trans>Status</Trans></Label>
												<select className="form-control" onChange={(e) => setStatus(e.target.value)}>
													<option value=''></option>
													<option value={1} selected={status == 1}><Trans>Active</Trans></option>
													<option value={0} selected={status == 0}><Trans>Non Active</Trans></option>
												</select>
											</div>

                                            <div className="form-group col-md-4 mt-2">
                                                <Label className="form-label"><Trans>Relate to order</Trans></Label>
                                                <select className="form-control" onChange={(e) => setRelateToOrder(e.target.value)}>
                                                    <option value=''></option>
                                                    <option value={1} selected={relateToOrder == 1}><Trans>Yes</Trans></option>
                                                    <option value={2} selected={relateToOrder == 2}><Trans>No</Trans></option>
                                                </select>
                                            </div>
											<div className="form-group col-md-4 mt-2">
												<Label className="form-label"><Trans>Driver Type</Trans></Label>
												<Select className="form-control" 
													name="addressType"
													options={driverTypes} 
													value={driverTypes.filter(el => el.value == driverTypeId)}
													onChange={(e) => setDriverTypeId(e.value)} />											
											</div>
										</Row>
										<div className="text-center  mt-4">
											<Button type="submit" color="danger">
												<Trans>Submit</Trans>
											</Button>
										</div>
									</CardBody>
								</Card>
							</Col>
							<Col xl={12}>
								<Row>

								</Row>
							</Col>
						</Row>
					</Form>
				</div>
			</div>
		</React.Fragment>
    )
}

export default EditTask
